<template>
  <div style="background: #f8f8f8;padding: 20px;" v-loading='loading'>
    <div class="container-zyb">
      <div class="info">
        <div>
          {{user.name}}的成绩：{{user.score}}
          <span v-if="user.first" style="margin-left: 10px;;">{{user.xuanke}}</span>
          <span v-if="user.isLocal">，地方专项学生</span>
        </div>
        <div class="info-btns">
          <div class="action-button" @click="onOut">导出</div>
          <div class="action-button" @click="saveSort">保存排序</div>
        </div>
      </div>
      <el-tabs v-model="sort" @tab-click="sortChange">
        <el-tab-pane label="默认排序" name="0"></el-tab-pane>
        <el-tab-pane label="按分数" name="1"></el-tab-pane>
        <el-tab-pane label="按学费" name="2"></el-tab-pane>
        <el-tab-pane label="按专业" name="3"></el-tab-pane>
        <el-tab-pane label="按地区" name="4"></el-tab-pane>
        <el-tab-pane label="按高校类型" name="5"></el-tab-pane>
        <el-tab-pane label="按公办" name="6"></el-tab-pane>
      </el-tabs>

      <div v-if="sort == 3 || sort == 4">
        <div>
          <el-tag type="warning" size="small" :effect="optionIndex == index ? 'dark' : 'light '"
            v-for="(item, index) of options" :key="sort == 3 ? item.type : item.province"
            @click="optionIndex = index, option = ''"
            style="margin-right: 12px;margin-bottom: 12px;cursor: pointer" v-if="item.show">{{sort == 3 ? item.type : item.province}}</el-tag>
        </div>

        <el-radio-group v-model="option" style="margin: 10px 0px;">
          <el-radio :label="item1" v-for="(item1,index1) in options[optionIndex].filings" @change="optionChange"
            :key="index1" v-if="item1.show">{{ sort == 3 ? item1.type : item1.city }}</el-radio>
        </el-radio-group>
      </div>

      <li class="item item-title">
        <div style="width: 30px;">序号</div>
        <div style="width: 60px;">院校代码</div>
        <div style="width: 60px;">专业代码</div>
        <div style="width: 160px;">院校</div>
        <div style="width: 160px;">专业</div>
        <div style="width: 100px;">城市</div>
        <div style="width: 130px;">专业门类</div>
        <div style="width: 50px;">首选</div>
        <div style="width: 80px;">再选</div>
        <div style="width: 50px;">学费</div>
        <div style="width: 120px;">级别</div>
        <div style="width: 100px;text-align: center;">均分</div>
        <!-- <div style="width: 50px;text-align: center;">排名</div> -->
        <div style="width: 40px;text-align: center;">学制</div>
        <div style="width: 90px;text-align: center;" title="2026密算">2026密算1</div>
        <div style="width: 60px;text-align: center;" >2026密算2</div>
        <div style="width: 40px;text-align: center;">{{user.year}}</div>
        <div style="width: 40px;text-align: center;">{{user.year - 1}}</div>
        <div style="width: 100px;">备注</div>
        <div style="width: 50px;">操作</div>
      </li>
      <ul @dragstart="onDragStart" @dragover="onDragOver" @dragend="onDragEnd" ref="parentNode">
        <li v-for="(item,index) in list" :key="index" class="item" draggable="true" :id="item.id">
          <div style="width: 30px;text-align: center;">{{index + 1}}</div>
          <div style="width: 60px;text-align: center;">{{item.collegeCode}}</div>
          <div style="width: 60px;text-align: center;">{{item.majorCode}}</div>
          <div style="width: 160px;" :title="item.collegeName">{{item.collegeName}}</div>
          <div style="width: 160px;" :title="item.majorName">{{item.majorName}}</div>
          <div style="width: 100px;" :title="item.city + '(' + item.province + ')'">{{item.city}}({{item.province}})
          </div>
          <div style="width: 130px;" :title="item.type1 + '(' + item.type + ')'">{{item.type1}}({{item.type}})</div>
          <div style="width: 50px;">{{item.first}}</div>
          <div style="width: 80px;" :title="item.second">{{item.second}}</div>
          <div style="width: 50px;">{{item.money}}</div>
          <div style="width: 120px;" :title="item.type4 + '/' + item.start">{{item.type4}}/{{item.start}}</div>
          <div style="width: 100px;text-align: center;" :title="item.quality">{{item.quality}}</div>
          <!-- #<div style="width: 50px;text-align: center;">{{item.level}}</div> -->
          <div style="width: 40px;text-align: center;">{{item.yearLength}}</div>
          <div style="width: 90px;text-align: center;">{{item.score}}</div>
          <div style="width: 60px;text-align: center;">{{item.undulate}}</div>
          <div style="width: 40px;text-align: center;" :title="'位次：' + (item.weici || '暂无')">{{item.score1}}</div>
          <div style="width: 40px;text-align: center;">{{item.scoreLast}}</div>
          <div style="width: 100px;text-align: center;" :title="item.remark">{{item.remark}}</div>
          <div style="width: 50px;">
            <el-popconfirm title="确定要删除这个志愿吗？" @confirm="del(item.id)">
              <span class="btn" slot="reference">删除</span>
            </el-popconfirm>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,

        id: this.$route.query.id,

        sort: '0',

        user: {},
        list: [],
        draging: null, //被拖拽的对象
        target: null, //目标对象

        optionIndex: 0,
        option: '',
        options: [],

        types: [],
        address: [],
      }
    },
    mounted() {
      this.id = this.$route.query.id

      //为了防止火狐浏览器拖拽的时候以新标签打开，此代码真实有效
      document.body.ondrop = function(event) {
        event.preventDefault();
        event.stopPropagation();
      }

      this.loadData()
    },
    methods: {
      onOut() {
        window.open(`${this.$api.baseURL}aspiration/out?id=${this.id}&sort=${this.sort}`)
      },
      loadData() {
        this.$api.post('aspiration/getById', {
          id: this.id,
          sort: this.sort
        }, res => {
          console.log(res)
          res.user.xuanke = res.user.first.substring(1, 2) + res.user.second0.substring(0, 1) + res.user.second1.substring(0, 1)
          this.user = res.user

          this.list = res.list
          this.findOptions()
        })
      },
      optionChange(e) {
        // 重新排序
        let list0 = []
        let list1 = []

        if (this.sort == 3) {
          for (let item of this.list) {
            if (item.type1 == e.type) {
              list0.push(item)
            } else {
              list1.push(item)
            }
          }

          if (list0.length == 0) {
            this.$message.error('暂无此学科')
            return
          }
        } else if (this.sort == 4) {
          for (let item of this.list) {
            if (item.city == e.city) {
              list0.push(item)
            } else {
              list1.push(item)
            }
          }

          if (list0.length == 0) {
            this.$message.error('暂无此城市')
            return
          }
        } else if (this.sort == 5) {
          let list11 = []
          let list12 = []
          for (let item of this.list) {
            if (item.type3 == '985') {
              list0.push(item)
            } else if (item.type3 == '211') {
              list11.push(item)
            } else {
              list12.push(item)
            }
          }
          list1 = list11.concat(list12)
          console.log(111, list1)
        } else if (this.sort == 6) {
          for (let item of this.list) {
            if (item.quality == '公办') {
              list0.push(item)
            } else {
              list1.push(item)
            }
          }
        }


        let list = list0.concat(list1)
        this.list = JSON.parse(JSON.stringify(list))
      },
      findOptions() {
        this.$api.post('filing/findOptions1', {
          year: this.user.year,
          id: this.$parent.user.id
        }, res => {
          for (let item of res.types) {
            item.isSelAll = false
            for (let item1 of item.filings) {
              item1.isSel = false

              for (let data of this.list) {
                if(item.type == data.type)
                  item.show = true
                if(item1.type ==  data.type1)
                  item1.show = true
              }
            }
          }

          for (let item of res.address) {
            item.isSelAll = false
            for (let item1 of item.filings) {
              item1.isSel = false

              for (let data of this.list) {
                if(item.province == data.province)
                  item.show = true
                if(item1.city ==  data.city)
                  item1.show = true
              }
            }
          }
          console.log(res.address)
          this.types = res.types
          this.address = res.address
        })
      },
      saveSort() {
        this.$alert('您确定要保存当前排序为默认排序吗？', '确定保存吗？', {
          confirmButtonText: '确定',
          callback: action => {
            if (action == 'confirm') {
              this.saveSortOk()
            }
          }
        });
      },
      saveSortOk() {
        let ids = []
        for (let item of this.$refs.parentNode.childNodes) {
          ids.push(item.id)
        }

        this.$api.post('aspiration/saveSort', {
          id: this.id,
          result: ids.join()
        }, res => {
          this.$message('保存成功')
          location.reload()
        })
      },
      del(id) {
        let ids = []
        for (let item of this.$refs.parentNode.childNodes) {
          if (id != item.id)
            ids.push(item.id)
        }

        this.$api.post('aspiration/saveSort', {
          id: this.id,
          result: ids.join()
        }, res => {
          this.$message('保存成功')
          location.reload()
        })
      },
      sortChange(e) {
        if (this.sort < 3) {
          this.loadData()
        } else if (this.sort == 3) {
          this.options = this.types
        } else if (this.sort == 4) {
          this.options = this.address
        } else if (this.sort == 5) {
          this.optionChange()
        } else if (this.sort == 6) {
          this.optionChange()
        }
      },
      // -----------------------  滑动  -----------------------------
      onDragStart(event) {
        this.draging = event.target;
      },
      onDragOver(event) {
        this.target = event.target;
        let targetTop = event.target.getBoundingClientRect().top;
        let dragingTop = this.draging.getBoundingClientRect().top;
        if (this.target.nodeName === "LI" && this.target !== this.draging) {
          if (this.target) {
            if (this.target.animated) {
              return;
            }
          }

          if (this._index(this.draging) < this._index(this.target)) {
            this.target.parentNode.insertBefore(this.draging, this.target.nextSibling);
          } else {
            this.target.parentNode.insertBefore(this.draging, this.target);
          }
          this._anim(targetTop, this.target);
          this._anim(dragingTop, this.draging);
        }
      },
      _anim(startPos, dom) {
        let offset = startPos - dom.getBoundingClientRect().top;
        dom.style.transition = "none";
        dom.style.transform = `translateY(${offset}px)`;

        //触发重绘
        dom.offsetWidth;
        dom.style.transition = "transform .3s";
        dom.style.transform = ``;
        //触发重绘
        // setTimeout(()=>{
        //     dom.style.transition="transform .3s";
        //     dom.style.transform=``;
        // },0)
        clearTimeout(dom.animated);

        dom.animated = setTimeout(() => {
          dom.style.transition = "";
          dom.style.transform = ``;
          dom.animated = false;
        }, 300)
      },
      onDragEnd(event) {
        let currentNodes = Array.from(this.$refs.parentNode.childNodes);

        let data = currentNodes.map((i, index) => {
          let item = this.data.find(c => c == i.innerText);
          return item
        });
      },
      _index(el) {
        let domData = Array.from(this.$refs.parentNode.childNodes);
        return domData.findIndex(i => i.innerText == el.innerText);
      },
    }
  }
</script>

<style>
  .container-zyb {
    width: 1430px;
    margin: 0 auto;
    background: #f8f8f8;
    padding: 20px 30px;
  }

  .container-zyb ul {
    list-style: none;
    padding-bottom: 20px;
  }

  .container-zyb .item {
    cursor: pointer;
    height: 34px;
    line-height: 34px;
    border-bottom: 1px solid #eee;
    color: #444;
    padding: 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    font-size: 13px;
  }

  .item-title {
    background: #f6f6f6;
    margin-bottom: 5px;
    color: #777;
    border: 0;
    border-radius: 0;
    position: sticky;
    top: 0;
  }

  .container-zyb .item>div {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .btn {
    cursor: pointer;
    color: blue;
  }

  .info {
    font-size: 21px;
    margin-bottom: 10px;
    display: flex;
    text-align: center;
    justify-content: space-between;
    align-items: center;
  }

  .info .info-btns {
    display: flex;
    align-items: center;
    text-align: center;
  }

  .action-button {
    padding: 3px 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    color: #4a4a4a;
    margin-left: 10px;
  }

  .el-radio {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/zyb.vue